import TutorBadge from './TutorBadge';

export default TutorBadge;
